'use strict';
define('pokerMap',[], function () {
	return {
		keyMap: {
			'PLAYER_1':'poker.hands.hand_1',
			'PLAYER_2':'poker.hands.hand_2',
			'PLAYER_3':'poker.hands.hand_3',
			'PLAYER_4':'poker.hands.hand_4',
			'PLAYER_5':'poker.hands.hand_5',
			'PLAYER_6':'poker.hands.hand_6',
			'COMB_1':'poker.combinations.high_card',
			'COMB_2':'poker.combinations.one_pair',
			'COMB_3':'poker.combinations.two_pairs',
			'COMB_4':'poker.combinations.three_of_a_kind',
			'COMB_5':'poker.combinations.straight',
			'COMB_6':'poker.combinations.flush',
			'COMB_7':'poker.combinations.full_house',
			'COMB_8':'poker.combinations.four_of_a_kind',
			'COMB_9':'poker.combinations.straight_flush',
			'COMB_10':'poker.combinations.royal_flush',
		},
		probMap: {
			'poker.hands.hand_1': { id: 301, prob: 181439 / 1000000 },
			'poker.hands.hand_2': { id: 302, prob: 181439 / 1000000 },
			'poker.hands.hand_3': { id: 303, prob: 181439 / 1000000 },
			'poker.hands.hand_4': { id: 304, prob: 181439 / 1000000 },
			'poker.hands.hand_5': { id: 305, prob: 181439 / 1000000 },
			'poker.hands.hand_6': { id: 306, prob: 181439 / 1000000 },
			'poker.combinations.high_card': { id: 321, prob: 133 / 250000 },
			'poker.combinations.one_pair': { id: 322, prob: 1611 / 10000 },
			'poker.combinations.two_pairs': { id: 323, prob: 2441 / 8000 },
			'poker.combinations.three_of_a_kind': { id: 324, prob: 139079 / 1000000 },
			'poker.combinations.straight': { id: 325, prob: 16603 / 100000 },
			'poker.combinations.flush': {id: 326, prob: 27073 / 250000 },
			'poker.combinations.full_house': { id: 327, prob: 21843 / 200000 },
			'poker.combinations.four_of_a_kind': { id: 328, prob: 4437 / 500000 },
			'poker.combinations.straight_flush': { id: 329, prob: 1567 / 1000000 },
			'poker.combinations.royal_flush': { id: 330, prob: 93 / 500000 }
		}
	};
});

